var activatingOrDeactivatingItem = false;

function activateArticle(model, id) {

  if (activatingOrDeactivatingItem) {
    return false;
  }

  $.ajax({
    url: '/admin/request/active',
    method: 'post',
    data: {
      ids: [id],
      model: model,
      active: 1
    },
    headers: {
      'X-CSRF-TOKEN': $('#csrf-token').val()
    },
    beforeSend: function () {
      activatingOrDeactivatingItem = true;
    },
    success: function (response) {
      activatingOrDeactivatingItem = false;
      if (response && response.success) {
        $('.flash-message__wrapper--preview').slideUp(400, function () {
          $(this).remove();
        });
        $('.flash-message__wrapper--activate').html('Der Beitrag wurde aktiviert');
        $('.flash-message__wrapper--activate').addClass('flash-message__wrapper--success');
        return;
      }
      error();
    },
    error: function () {
      activatingOrDeactivatingItem = false;
      ajaxError();
    }
  });
}
